import { Button } from '@cluey/cluey-components';
import { useEffect } from 'react';
import { generatePath, useHistory } from 'react-router';

import { Student } from '../../../../../api/types/student';
import checkIcon from '../../../../../assets/images/icon-outline-checked.svg';
import { ShadowContainer } from '../../../../../components/ShadowContainer';
import type { FormFlowProps } from '../../../../../types/hubInterfaces';
import { PATH_HUB_HOME, PATH_HUB_STUDENT_PROFILE } from '../../../../../util/pagePath';
import { usePageHeader } from '../../../../../v2/app-shell/usePageHeader';

interface Props {
  formFlowProps: FormFlowProps;
}

type HistoryState = {
  newStudent?: Student;
  fromAddStudentSuccess?: boolean;
};

const AddStudentSuccess = ({ formFlowProps }: Props) => {
  const history = useHistory<HistoryState>();
  const newStudent = history.location.state?.newStudent;
  const { firstName, lastName } = newStudent || {};

  const { jump } = formFlowProps;
  useEffect(() => {
    if (!firstName) {
      jump(0);
    }
  }, [firstName, jump]);

  const { setHeader } = usePageHeader();

  useEffect(() => {
    setHeader({
      label: 'Students',
      showIcon: false,
      showBackButton: true,
    });
  }, [setHeader]);

  const onGoToProfileClick = () => {
    if (newStudent) {
      const profilePath = generatePath(PATH_HUB_STUDENT_PROFILE, { studentSfid: newStudent.studentId });
      history.push(profilePath, { fromAddStudentSuccess: true });
    } else {
      history.push(PATH_HUB_HOME);
    }
  };

  return (
    <div className="md:max-w-4/5 md:w-4/5">
      <ShadowContainer className="flex flex-col items-center gap-6 !rounded-3xl bg-white p-6 md:!p-10">
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full">
            <img src={checkIcon} alt="Check" />
          </div>
          <h1 className="font-merriweather text-[32px] font-bold text-grey-600">Welcome {firstName}</h1>
        </div>
        <p className="text-center text-lg text-grey-600">
          We've created a student profile for {firstName} {lastName}.
        </p>
        <Button
          onClick={onGoToProfileClick}
          size="sm"
          appearance="reverse"
          className="flex h-10 w-auto items-center justify-center !border text-base !font-medium tracking-wide text-grey-400"
        >
          Go to {firstName}'s profile
        </Button>
      </ShadowContainer>
    </div>
  );
};

export { AddStudentSuccess };
